module.exports = __webpack_public_path__ + "static/media/download.51f34df6.svg";